import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const edificiosAdapter = createEntityAdapter({
    selectId: (x) => x.edificioId,
});
const initialState = edificiosAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getEdificios: builder.query({
            query: () => 'edificios',
            transformResponse: responseData => {
                return edificiosAdapter.setAll(initialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'Edificios', id: 'LIST' }
            ]
        }),
        addEdificio: builder.mutation({
            query: (newEdificio) => ({
                url: 'edificio',
                method: 'post',
                body: newEdificio
            }),
            invalidatesTags: ["Edificios", "Departamentos"]
        }),
        editEdificio: builder.mutation({
            query: (edificioUpdated) => ({
                url: 'edificio',
                method: 'put',
                body: edificioUpdated
            }),
            invalidatesTags: ["Edificios", "Departamentos"]
        }),

        deleteEdificios: builder.mutation({
            query: (idsEdificiosToDelete) => ({
                url: 'edificios',
                method: 'delete',
                body: idsEdificiosToDelete
            }),
            invalidatesTags: ["Edificios"]
        }),
    })
});


export const { useGetEdificiosQuery, useAddEdificioMutation, useEditEdificioMutation, useDeleteEdificiosMutation } = extendedApiSlice;

//A: returns the query result object
export const selectEdificiosResult = extendedApiSlice.endpoints.getEdificios.select();

//A: created memoized selector
const selectEdificiosData = createSelector(
    selectEdificiosResult,
    edificiosResult => edificiosResult.data  //A: normalized state object with ids and entities
);
export const {
    selectAll: selectAllEdificios,
    selectById: selectEdificiosById,
    selectIds: selectEdificioIds
  } = edificiosAdapter.getSelectors(state => selectEdificiosData(state) ?? initialState);
